<template>
    <v-dialog v-model="dialog" width="600" scrollable>
        <v-card :disabled="load">
            <v-card-title class="pb-2">
                Autoasignar ticket N° {{ ticket?.ticket_id || '' }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-6">
                <v-form ref="form">
                    <v-row>
                        <!-- 
                        prioridad
                        tipo
                        area
                        empresa
                        sucursal
                         -->
                        <v-col v-if="!ticket?.tipo_ticket_id" cols="12" sm="12" class="py-0">
                            <v-autocomplete v-model="data.tipo_ticket" label="Tipo" item-text="nombre"
                                item-value="tipo_id" :items="tipos_tickets" outlined dense clearable
                                :rules="[rules.required]" validate-on-blur></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="6" class="py-0">
                            <v-autocomplete v-model="data.prioridad" label="Prioridad" item-text="nombre"
                                item-value="prioridad_id" :items="prioridades" outlined dense
                                clearable></v-autocomplete>
                        </v-col>
                        <v-col v-if="!ticket?.origen_id" cols="6" sm="6" class="py-0">
                            <v-autocomplete v-model="data.origen" label="Origen" item-text="nombre"
                                item-value="origen_id" :items="origenes" outlined dense clearable
                                :rules="[rules.required]" validate-on-blur></v-autocomplete>
                        </v-col>
                        <v-col v-if="!ticket?.area_id" cols="6" sm="6" class="py-0">
                            <v-autocomplete v-model="data.area" label="Area" item-text="nombre" item-value="area_id"
                                :items="areas" outlined dense clearable :rules="[rules.required]"
                                validate-on-blur></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-end pb-4">
                <v-btn color="error" class="mr-3" :disabled="load" @click="dialog = false">
                    Cancelar
                </v-btn>
                <BtnConfirmar :loading="load" @action="guardar()" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import BtnConfirmar from '../util/BtnConfirmar.vue';

export default {
    data() {
        return {
            load: false,
            local: null,
            rules: {
                required: value => !!value || 'Campo requerido'
            },
            data: {
                tipo_ticket: null,
                area: null,
                prioridad: null,
                origen: null,
                empresa: null,
                sucursal: null
            },
        }
    },

    props: {
        value: Boolean,
        empresas: {
            type: Array,
            default: []
        },

        prioridades: {
            type: Array,
            default: []
        },

        tipos_tickets: {
            type: Array,
            default: []
        },

        areas: {
            type: Array,
            default: []
        },

        origenes: {
            type: Array,
            default: []
        },

        ticket: {
            type: Object,
            default: {}
        }
    },

    async created() {

    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        ...mapState('genericos', ['sucursales'])
    },
    components: {
        BtnConfirmar,
    },
    watch: {
        dialog(val) {
            if (val) {
                this.data = {
                    empresa: this.ticket?.empresa_id,
                    sucursal: this.ticket?.sucursal_id,
                    tipo_ticket: this.ticket?.tipo_ticket_id,
                    area: this.ticket?.area_id,
                    prioridad: this.ticket?.prioridad_id,
                    origen: this.ticket?.origen_id
                }
            } else {
                this.data = {
                    empresa: null,
                    sucursal: null,
                    tipo_ticket: null,
                    area: null,
                    prioridad: null,
                    origen: null
                }
            }
        },
    },
    methods: {
        async guardar() {
            this.$store.state.loading = true
            await this.$store.dispatch('tickets/editarTicket', {
                ...this.data,
                ticket_id: this.ticket?.ticket_id
            }).then(async res => {
                if (res.exito) {

                    // ACA AUTOASIGNAR 
                    await this.$store.dispatch('tickets/autoasignarTicket', {
                        ticket_id: this.ticket?.ticket_id
                    }).then(async res => {
                        if (res.exito) {
                            // Encontrar el índice del ticket
                            this.$emit('actualizarTicket', res.data)
                            this.dialog = false
                            await this.$swal.fire({
                                icon: 'success',
                                title: res.message,
                            })

                        } else {
                            this.$store.dispatch('show_snackbar', {
                                text: res.message,
                                color: 'error'
                            });
                        }
                    }).catch(error => {
                        this.$store.dispatch('show_snackbar', {
                            text: error.message,
                            color: 'error'
                        });
                        return
                    })



                } else {
                    this.$store.dispatch('show_snackbar', {
                        text: res.message,
                        color: 'error'
                    })
                }
            }).catch(error => {
                this.$store.dispatch('show_snackbar', {
                    text: error.message,
                    color: 'error'
                })
            })
            this.$store.state.loading = false
        },

        setSucursal() {
            const sucursal = this.sucursales.filter(
                suc => suc.familia_id === this.data.empresa
            )
            sucursal.length === 1 ? (this.filtro.sucursal = sucursal[0].id) : null
        },

        limpiar() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>